'use strict';

module.exports = function () {
    if ($("#loggedInStatus").val() === 'true') {
        var sessionTimeoutTime = parseInt($("#logoutWarningTime").val()) * 1000;
        var autoLogoutInterval;
        var logoutWarningInterval;

        // shows session session timeout modal and after xx secs logout customer and shows signin modal
        function showSessionTimeoutModal() {
            if (!$('#sessionTimeoutModal').is(':visible') && !$('#signinModal').is(':visible')) {
                $('#countdowntimer').html(parseInt($("#autoLogoutTime").val()));
                $("#sessionTimeoutModal").modal({keyboard: false, backdrop: 'static'});

                var timeleft = parseInt($("#autoLogoutTime").val());
                autoLogoutInterval = setInterval(function(){
                    timeleft--;
                    if ($('#countdowntimer').length) {
                        $('#countdowntimer').html(timeleft);
                    }
                    if (timeleft <= 1){
                        clearInterval(autoLogoutInterval);
                        clearInterval(logoutWarningInterval);
                        $.ajax({
                            url: $("#sessionTimeoutModal").data('logout'),
                            type: 'get',
                            success: function () {
                                if ($('#checkout-main').length) {
                                    localStorage.setItem('openSessionSignInModal', true);
                                    window.location.href = $("#sessionTimeoutModal").data('homeurl');
                                } else {
                                    $('body').trigger('signinModal:open', [$("#sessionTimeoutModal").data('login'), null, true]);
                                }
                            }
                        });
                    }
                },1000);
            }
        }

        function hideSessionTimeoutModal() {
            if ($('#sessionTimeoutModal').is(':visible')) {
                $('#sessionTimeoutModal').modal('hide');
                clearInterval(autoLogoutInterval);
            }
        }

        // Update shared activity timestamp
        function updateActivity() {
            localStorage.setItem('lastActivity', Date.now());
            hideSessionTimeoutModal();
        }

        // reset session timeout timer
        $(document).on('keydown click', function() {
            if (!$('#sessionTimeoutModal').is(':visible') && !$('#signinModal').is(':visible')) {
                updateActivity();
            }
        });
        $('.stay-signed-in, #sessionTimeoutModal .close').on('click', function () {
            updateActivity();
        });

        // Cross-tab listener: reset if activity happens in another tab
        window.addEventListener('storage', function (event) {
            if (event.key === 'lastActivity') {
                hideSessionTimeoutModal();
            }
        });

        // Periodically check for inactivity
        logoutWarningInterval = setInterval(function () {
            var last = parseInt(localStorage.getItem('lastActivity'), 10) || Date.now();
            var inactiveTime = Date.now() - last;

            if (inactiveTime >= sessionTimeoutTime) {
                showSessionTimeoutModal();
            } else {
                hideSessionTimeoutModal();
            }
        }, 10000);

        updateActivity();
    }
};
